/**
 * The query string shared by the three paged lists - the Backlog column, the
 * bug list and the support queue (see api/lib/pagination.js on the server).
 *
 * Empty filters are dropped rather than sent as `status=`: the selects clear to
 * "" (see Store.js's filter slices), and a filter nobody selected shouldn't
 * appear in the URL at all - it makes the request the browser's network tab
 * shows say what was actually asked for.
 */
export const pageParams = ({filters, limit, cursor} = {}) => {
    const params = {};

    Object.entries(filters || {}).forEach(([key, value]) => {
        if (value === "" || value === null || value === undefined) return;
        params[key] = value;
    });

    if (limit !== undefined) params.limit = limit;
    // Absent on the first page, and never invented - the server answers 400 for
    // a cursor it didn't write, on purpose (a quiet restart from the top is how
    // a reader ends up never seeing the middle of a list).
    if (cursor) params.cursor = cursor;

    return params;
};
